<template>
  <div>
    <h1>Aktion anlegen</h1>

    <mia-offer-prices-form
      ref="form"
      v-model="form"
      @validation-changed="isValid = $event"
    />

    <div class="flex justify-end mt-8">
      <button
        class="inline-flex items-center h-10 px-4 py-2 ml-4 text-gray-100 bg-blue-600 rounded focus:outline-none focus:shadow-outline"
        :class="{
          'hover:bg-blue-700': isValid && !$wait.any,
          'opacity-75': !isValid || $wait.any
        }"
        :disabled="!isValid || $wait.any"
        type="button"
        @click="create"
      >
        <mia-spinner
          v-if="$wait.is('creating offer')"
          class="w-6 h-6 text-white"
        />

        <span class="ml-2">
          Aktion anlegen
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { createOffer } from '@/api/offerPrices'
import Spinner from '@/components/ui/loader/Spinner.vue'
import OfferPricesForm from '@/components/cars/offer-prices/Form.vue'

export default {
  name: 'MiaOfferPricesCreate',

  components: {
    'mia-offer-prices-form': OfferPricesForm,
    'mia-spinner': Spinner
  },

  data() {
    return {
      form: {
        title: '',
        is_active: true,
        starts_at: '',
        ends_at: '',
        cars: []
      },

      isValid: false
    }
  },

  computed: {
    ...mapGetters(['vatRate']),
    ...mapGetters('offerPrices', ['calculation'])
  },

  created() {
    this.$store.commit('offerPrices/resetCalculation', { vatRate: this.vatRate })
  },

  mounted() {
    eventBus.$emit('mia-set-breadcrumb', [
      {
        link: {
          path: '/cars'
        },
        text: 'Fahrzeuge'
      },
      {
        link: {
          path: '/cars/offer-prices'
        },
        text: 'Aktionspreise'
      },
      {
        link: {
          path: '/cars/offer-prices/create'
        },
        text: 'Aktion anlegen'
      }
    ])
  },

  methods: {
    async create() {
      this.$wait.start('creating offer')

      const offer = await createOffer({
        ...this.form,
        calculation: this.calculation
      })

      this.$store.commit('offerPrices/addOffer', offer)
      this.$wait.end('creating offer')

      eventBus.$emit('mia-info', {
        info: ['Aktion erfolgreich angelegt.']
      })

      this.$router.push(`/cars/offer-prices/${offer.id}`)
    }
  }
}
</script>
